'use strict';
import * as $j_app$002e$002dClient$002dMain$0024 from "./app.-Client-Main$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $s_Lapp_ClientMain__main__AT__V(args) {
  $j_app$002e$002dClient$002dMain$0024.$m_Lapp_ClientMain$().main__AT__V(args);
}
export { $s_Lapp_ClientMain__main__AT__V as $s_Lapp_ClientMain__main__AT__V };
//# sourceMappingURL=app.-Client-Main.js.map
